import { Link } from 'react-router-dom';
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from 'react';

import { Radio, Button, Input, Space, message, Carousel, Divider, Flex, Segmented } from 'antd';
import callAPI from '../../comps/fetch/main'
import {
  InstagramOutlined,
  LockOutlined,
  MailOutlined,
  CheckCircleOutlined,
  StarFilled
} from '@ant-design/icons';
import './main.css'
import { trackStartedSignup } from '../../funcs/metaPixel';

// ========================================
// TICKER DATA - Update reviews and creators here
// ========================================

const REVIEWS_DATA = [
  {
    text: "We have moved our business from",
    highlightText: " Manychat to InstantDM. I am getting the same product at one-third of the price",
    fullText: "I was paying to Manychat.",
    author: "Yogendra Nathany - Coach"
  },
  {
    text: "I have to say this is",
    highlightText: "one of the best automation app i have used",
    fullText: "instagram & facebook automation, and best part is the customer service that they provide.",
    author: "DULHAN JEWELS - Brand, Shopify & Retail"
  },
  {
    text: "Absolutely wonderful.",
    highlightText: "The best that I have found. Super helpful and super reasonable pricing",
    fullText: "Will stick around for sure, would highly recommend.",
    author: "Victor Vigil"
  },
  {
    text: "This platform is",
    highlightText: "very good and makes automation easy",
    fullText: "to understand and use.",
    author: "Avinash - Coach"
  },
  {
    text: "It has",
    highlightText: "simplified our communication process. The interface is user-friendly",
    fullText: "and the automation features help us respond faster and stay organized.",
    author: "Skill Radar - Coach"
  },
  {
    text: "I really like instantDM.",
    highlightText: "It has been very helpful and at such a great price.",
    fullText: "I highly recommend it.",
    author: "Mark Lee - Creator, Entrepreneur"
  },
  {
    text: "Very",
    highlightText: "easy to use, lot of great features",
    fullText: "and is very affordable.",
    author: "MENTSMART PRIVATE LIMITED - Business & Store"
  },
];

const CREATORS_DATA = [
  // From HTML Document 1
  {
    image: "https://framerusercontent.com/images/k0bfRSzEQXeIQZd6I3DNGrepvQ0.jpg",
    name: "@yamahaindonesia",
    niches: ["Brand", "Retail Store", "Niche 3"],
    followers: "1.5 Million+"
  },
  {
    image: "https://framerusercontent.com/images/TYactyMkUxAa6akdPDzudte2tSo.png",
    name: "artificialntellligence",
    niches: ["AI", "Community", "Education"],
    followers: "1.5 Million+"
  },
  {
    image: "https://framerusercontent.com/images/V1cGFdx7Nh5RAZoW2ua2BI6lpo4.png",
    name: "Kitchen Stories",
    niches: ["Food & Kitchen", "Community", "1 Million+ Download"],
    followers: "300K+"
  },
  {
    image: "https://framerusercontent.com/images/u1TqjUQtTA1JioKdRZ1F8qDg.png",
    name: "HCL GUVI",
    niches: ["Institution", "Carrer Guidence"],
    followers: "280K+"
  },
  {
    image: "https://framerusercontent.com/images/J4hlheRnQUXnK9mvy5NT9kisiFU.png",
    name: "DEBELLIN | TOP BRAND 2021-2025",
    niches: ["Brand", "Life Style"],
    followers: "260K+"
  },

  // From HTML Document 2
  {
    image: "https://framerusercontent.com/images/0qrO9deXJDS7wAugY2eIpnxEJwE.png",
    name: "Mridul Madhok",
    niches: ["Influencer", "Youtuber", "Community Builder"],
    followers: "3 Million+"
  },
  {
    image: "https://framerusercontent.com/images/DjvLzI1Wb9L9tYqRD0fI2N1FODk.png",
    name: "@jeemboombhaa",
    niches: ["Influencer", "Regional Creator"],
    followers: "2.2 Million+"
  },
  {
    image: "https://framerusercontent.com/images/sD2rjLg5BQwaQHaMzPpoliwDVMo.png",
    name: "@praveendheiveegan",
    niches: ["Influencer", "Regional Creator"],
    followers: "900K+"
  },
  {
    image: "https://framerusercontent.com/images/Amhy8pmYNIkaQGwrnTHGZJK7jZ0.png",
    name: "@ biancamoratto",
    niches: ["Influencer", "Regional Creator", "Affiliate Marketing"],
    followers: "1 Million"
  },
  {
    image: "https://framerusercontent.com/images/D4iQt8YspYEDK84l6zFNF0St8.png",
    name: "@techfactsrafee",
    niches: ["Influencer", "Regional Creator", "Affiliate Marketing"],
    followers: "400K+"
  },
  {
    image: "https://framerusercontent.com/images/8YNlZX3uINeSDIjSlQU857k0ig.png",
    name: "@harley.digital",
    niches: ["Influencer", "Digital Seller", "Stan Store"],
    followers: "400K+"
  },

  // From HTML Document 3
  {
    image: "https://framerusercontent.com/images/5Hs7kPCwRnVFFNXLUSpO3KxqdO8.png",
    name: "Harsh kharole l Travel",
    niches: ["Travel Creator", "Life Style"],
    followers: "700K+"
  },
  {
    image: "https://framerusercontent.com/images/PvwPwZv9zvqVA1XbRG9UynAe4U.png",
    name: "tutinnitut",
    niches: ["UGC", "Skin Care"],
    followers: "130K+"
  },
  {
    image: "https://framerusercontent.com/images/JTxY7d4ZRjAaBgJY3ygZp1ayYSg.png",
    name: "Mumbai Bucketlist",
    niches: ["Events & Party", "Life Style"],
    followers: "400K+"
  },
  {
    image: "https://framerusercontent.com/images/S65mS9ovwgr2lpsKQlCgNr53x1k.png",
    name: "Made In Mumbai",
    niches: ["Events & Party", "Life Style"],
    followers: "200K+"
  },
  {
    image: "https://framerusercontent.com/images/yAEXkQLGYNeRJwAs6pvPyccNgWA.png",
    name: "Che'Nelle (シェネル)",
    niches: ["Pop Singer", "Life Style", "Artist"],
    followers: "130K+"
  },
  {
    image: "https://framerusercontent.com/images/CU3jN52dP9Qe2XfOBX6zewawO3I.png",
    name: "Yellow Zebra Safaris",
    niches: ["Tours & Travels", "Life Style", "Agency"],
    followers: "20K+"
  },
  {
    image: "https://framerusercontent.com/images/gNqK2qalR5oqzVHLPPK5ECLbw.png",
    name: "Bangalore Flats",
    niches: ["Real Estate", "Regional Creator", "Agency"],
    followers: "30K+"
  },
  {
    image: "https://framerusercontent.com/images/3XIVyWtqEC45LToT1QEA1tcGNE.png",
    name: "MAHI",
    niches: ["Fitness", "Wellness", "Lifestyle"],
    followers: "80K+"
  },

  // From HTML Document 5
  {
    image: "https://framerusercontent.com/images/VFq765JQXZvmiIO589ROgdwS4.png",
    name: "Computer Coach & Excel Expert",
    niches: ["Guru", "Digital Seller"],
    followers: "1.4 Million+"
  },
  {
    image: "https://framerusercontent.com/images/vM4VWtAmiKZgu4geUZCr4czJg4.png",
    name: "hybridfitnessindia",
    niches: ["Trainer"],
    followers: "700K+"
  },
  {
    image: "https://framerusercontent.com/images/q6opsgK3XhrWl2I9hS9krotAA.png",
    name: "Inglese per Italiani",
    niches: ["Coach", "Digital Seller"],
    followers: "160K+"
  },
  {
    image: "https://framerusercontent.com/images/JPATJuDUsSmf8xSyAHqu3r0fOIk.png",
    name: "Namma College",
    niches: ["Coach", "Career Guidance", "Institution"],
    followers: "200K+"
  },
  {
    image: "https://framerusercontent.com/images/b1RC5Nzs7V30elHOs5vpxmVjb30.png",
    name: "Businesskul",
    niches: ["Coach", "Business Consultant", "Institution"],
    followers: "200K+"
  },
  {
    image: "https://framerusercontent.com/images/lK4UHOloJFwpTXQKJG0Ca1ndwY.png",
    name: "@ bolt_officiall",
    niches: ["Influencer", "Regional Creator", "Affiliate Marketing"],
    followers: "500K+"
  },
  {
    image: "https://framerusercontent.com/images/xl63NXTeOEqVcX96EZ405CDv6w.png",
    name: "Sai Krisha Stores",
    niches: ["Retail Store", "Entrepreneur"],
    followers: "600K+"
  },
  {
    image: "https://framerusercontent.com/images/FeOMwOvx3QhQJFcQzLCDhgXj0rw.png",
    name: "MahaLakaxmi Fashion",
    niches: ["Retail Store", "Fashion", "Boutique"],
    followers: "430K+"
  },
  {
    image: "https://framerusercontent.com/images/vtSrI43gXKbUcHQ5JGk340ffvaw.png",
    name: "Sherin ◦ Geschenkideen",
    niches: ["Amazon Storefront", "Shopify", "TEMU"],
    followers: "360K+"
  },
  {
    image: "https://framerusercontent.com/images/G2hxLm9L0fRyLAlnnhYVtG6JGI.png",
    name: "Sri LNS Brand Jewellery",
    niches: ["Retail Store", "Shopify", "Apparel"],
    followers: "360K+"
  },
  {
    image: "https://framerusercontent.com/images/YAPBe00oD9FFwkzuZRQZgEUkU.png",
    name: "Bilberry Home & Hangers",
    niches: ["Retail Store", "Shopify", "Lifestyle"],
    followers: "360K+"
  },
  {
    image: "https://framerusercontent.com/images/gFuFG1Hkmce4wQC9ecPt1iWmQa4.png",
    name: "Dulhan Jewels",
    niches: ["Retail Store", "Shopify", "Apparel"],
    followers: "227K+"
  },
  {
    image: "https://framerusercontent.com/images/j8w5pIu3WvGdyvmT23we6Gdk.png",
    name: "Laeila♥︎",
    niches: ["Boutique", "Shopify", "Lifestyle"],
    followers: "360K+"
  },
  {
    image: "https://framerusercontent.com/images/6RvsmZEyaPEOJRe81oHxTMma8.png",
    name: "THE GIFT MAKERS",
    niches: ["Gifting", "Small Business"],
    followers: "360K+"
  }
];


function AuthPage() {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const location = useLocation();
  const isSignup = location.pathname === '/signup';

  const urlParams = new URLSearchParams(window.location.search);
  const ncid = urlParams.get('ncid');

  if (ncid) {
    localStorage.setItem("ncid", ncid);
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    const fbclickid = params.get('fbclickid');

    const urlParams = {};
    for (const [key, value] of params.entries()) {
      urlParams[key] = value;
    }
    localStorage.setItem('signup_full_params', JSON.stringify(urlParams));

    if (ref) {
      localStorage.setItem('refCode', ref);
    }
    if (fbclickid) {
      localStorage.setItem('fbclickid', fbclickid);
    }

    // Track Meta Pixel: User started signup (saw onboarding)
    if (isSignup) {
      trackStartedSignup();
    }
  }, [isSignup]);

  // Instagram OAuth URL
  const scopes = "business_basic,business_content_publish,business_manage_comments,business_manage_messages";
  const appId = "996086435858506";
  const redirectURL = "https://app.instantdm.com/fb-rdr";
  const instagramAuthUrl = `https://www.instagram.com/oauth/authorize?client_id=${appId}&redirect_uri=${redirectURL}&response_type=code&scope=${scopes}`;

  const handleInstagramLogin = () => {
    localStorage.setItem("signup-flow", true);
    window.location.href = instagramAuthUrl;
  };

  // ========================================
  // LOGIN COMPONENT
  // ========================================
  function LoginComp() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);
    const [response, setResponse] = useState({});
    const [payload, setPayload] = useState({});

    // Toggle for showing email login form
    const [showEmailLogin, setShowEmailLogin] = useState(false);

    // OTP Login States
    const [loginMode, setLoginMode] = useState('otp');
    const [otpStep, setOtpStep] = useState('email');
    const [otp, setOtp] = useState('');
    const [otpTimer, setOtpTimer] = useState(0);
    const [otpSending, setOtpSending] = useState(false);
    const [otpVerifying, setOtpVerifying] = useState(false);

    // Check for token and redirect URL in params
    const urlParamsLogin = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParamsLogin.get('token');
    const redirectUrl = urlParamsLogin.get('redirect');

    // OTP Timer countdown
    useEffect(() => {
      let interval = null;
      if (otpTimer > 0) {
        interval = setInterval(() => {
          setOtpTimer((timer) => timer - 1);
        }, 1000);
      }
      return () => clearInterval(interval);
    }, [otpTimer]);

    // Auto-login with token from URL
    useEffect(() => {
      if (tokenFromUrl) {
        messageApi.open({
          key: "auto-login",
          type: 'loading',
          content: 'Logging you in automatically...',
        });

        localStorage.setItem("token", tokenFromUrl);
        sessionStorage.clear();
        localStorage.removeItem("refCode");

        const params = new URLSearchParams(window.location.search);
        const showCollabUnlock = params.get('show-collab-unlock-model');

        if (showCollabUnlock === 'true') {
          window.location.href = `/ig?show-collab-unlock-model=true`;
          return;
        }

        if (redirectUrl) {
          window.location.href = redirectUrl;
        } else {
          navigate('/');
        }
      }
    }, [tokenFromUrl]);

    // Handle successful login response
    const handleLoginSuccess = (data) => {
      localStorage.setItem("token", data.token);
      sessionStorage.clear();
      localStorage.removeItem("refCode");
      localStorage.setItem("userData", JSON.stringify(data.data));
      localStorage.setItem("agency", true);

      if (data?.agency === true) {
        localStorage.setItem("agency-token", data.token);
        if (redirectUrl) {
          window.location.href = redirectUrl;
          return;
        }
        navigate("/");
        return;
      }

      if (redirectUrl) {
        window.location.href = redirectUrl;
        return;
      }
      const params = new URLSearchParams(window.location.search);
      const showCollabUnlock = params.get('show-collab-unlock-model');

      if (showCollabUnlock === 'true') {
        window.location.href = `/ig?show-collab-unlock-model=true`;
        return;
      }

      data?.default_page?.id !== undefined ? navigate('/') : navigate('/ig-connect?show_ig_connect=true');
    };

    useEffect(() => {
      if (response?.code === 200) {
        handleLoginSuccess(response.data);
      }
      if (response?.code !== undefined && response.code !== 200) {
        messageApi.open({
          type: 'error',
          content: response.message,
        });
        setResponse({});
      }
    }, [response]);

    useEffect(() => {
      if (payload?.email) {
        setSubmitting(true);
        messageApi.open({
          key: "login loading",
          type: 'loading',
          content: 'Logging you in...',
        });
        callAPI({ url: 'user-login', method: "PUT", body: payload, loadingState: setSubmitting, dataState: setResponse });
      }
    }, [payload]);

    // Send OTP to email
    const handleSendOtp = () => {
      const validationErrors = {};
      if (!email) {
        validationErrors.email = 'Email is required';
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
        validationErrors.email = 'Invalid email address';
      }

      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
      }

      setErrors({});
      setOtpSending(true);
      messageApi.open({
        key: "otp-send",
        type: 'loading',
        content: 'Sending OTP to your email...',
      });

      callAPI({
        url: `otp_login_email?email_id=${email}`,
        method: 'PUT',
        body: {},
        loadingState: setOtpSending,
        dataState: (data) => {
          messageApi.destroy("otp-send");
          if (data?.code === 200) {
            messageApi.success('OTP sent to your email!');
            setOtpStep('verify');
            setOtpTimer(60);
            setOtp('');
          } else {
            messageApi.error(data?.message || 'Failed to send OTP. Please try again.');
          }
        }
      });
    };

    // Verify OTP and login
    const handleVerifyOtp = () => {
      const validationErrors = {};
      if (!otp) {
        validationErrors.otp = 'OTP is required';
      } else if (otp.length !== 6) {
        validationErrors.otp = 'OTP must be 6 digits';
      }

      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
      }

      setErrors({});
      setOtpVerifying(true);
      messageApi.open({
        key: "otp-verify",
        type: 'loading',
        content: 'Verifying OTP...',
      });

      callAPI({
        url: `otp_login_verify`,
        method: 'PUT',
        body: { otp, email_id: email },
        loadingState: setOtpVerifying,
        dataState: (data) => {
          messageApi.destroy("otp-verify");
          if (data?.code === 200) {
            messageApi.success('OTP verified successfully!');
            handleLoginSuccess(data.data);
          } else {
            messageApi.error(data?.message || 'Invalid OTP. Please try again.');
          }
        }
      });
    };

    // Handle password login
    const handleLogin = () => {
      const validationErrors = {};
      if (!email) {
        validationErrors.email = 'Email is required';
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
        validationErrors.email = 'Invalid email address';
      }

      if (!password) {
        validationErrors.password = 'Password is required';
      }
      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
      } else {
        setErrors({});
        setPayload({ email, password });
      }
    };

    // Reset OTP flow
    const resetOtpFlow = () => {
      setOtpStep('email');
      setOtp('');
      setOtpTimer(0);
      setErrors({});
    };

    return (
      <>
        {/* Instagram Login - Primary Option */}
        <Button
          className="social-login-btn instagram"
          onClick={handleInstagramLogin}
          icon={<InstagramOutlined />}
          size='large'
        >
          Continue With Instagram
        </Button>
        <p className="secure-login-note">
          <LockOutlined /> Secured login using official Instagram API
        </p>

        {/* Continue with Email Button - Toggles email form */}
        {!showEmailLogin ? (
          <Button
            className="auth-switch-btn"
            onClick={() => setShowEmailLogin(true)}
            icon={<MailOutlined />}
            style={{ marginTop: '12px' }}
          >
            Continue with Email
          </Button>
        ) : (
          <>
            <div className="auth-divider">
              <span>login with email</span>
            </div>

            {/* Login Mode Toggle */}
            <div className="login-mode-toggle">
              <Segmented
                value={loginMode}
                onChange={(value) => {
                  setLoginMode(value);
                  setErrors({});
                  if (value === 'otp') {
                    setOtpStep('email');
                    setOtp('');
                    setOtpTimer(0);
                  }
                }}
                options={[
                  {
                    label: (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 12px' }}>
                        <MailOutlined />
                        <span>OTP Login</span>
                      </div>
                    ),
                    value: 'otp',
                  },
                  {
                    label: (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 12px' }}>
                        <LockOutlined />
                        <span>Password</span>
                      </div>
                    ),
                    value: 'password',
                  },
                ]}
                block
              />
            </div>

            <div className="auth-form-fields">
              {/* Password Login */}
              {loginMode === 'password' && (
                <>
                  <Input
                    className="auth-input"
                    placeholder='Enter your email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    size="large"
                    disabled={submitting}
                    onPressEnter={handleLogin}
                  />
                  {errors.email && <p className='auth-error'>{errors.email}</p>}

                  <Input.Password
                    className="auth-input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder='Enter your password'
                    size="large"
                    disabled={submitting}
                    onPressEnter={handleLogin}
                  />
                  {errors.password && <p className='auth-error'>{errors.password}</p>}

                  <Button
                    type="primary"
                    className="auth-submit-btn"
                    size="large"
                    onClick={handleLogin}
                    loading={submitting}
                  >
                    Login
                  </Button>

                  <div className="forgot-password-link">
                    <a href='/reset-password' target='_blank'>Forgot password?</a>
                  </div>
                </>
              )}

              {/* OTP Login */}
              {loginMode === 'otp' && (
                <>
                  {otpStep === 'email' && (
                    <>
                      <Input
                        className="auth-input"
                        placeholder='Enter your email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        size="large"
                        disabled={otpSending}
                        onPressEnter={handleSendOtp}
                      />
                      {errors.email && <p className='auth-error'>{errors.email}</p>}

                      <Button
                        type="primary"
                        className="auth-submit-btn"
                        size="large"
                        onClick={handleSendOtp}
                        loading={otpSending}
                      >
                        Send OTP
                      </Button>
                      <p className="otp-info">We'll send a 6-digit code to your email</p>
                    </>
                  )}

                  {otpStep === 'verify' && (
                    <>
                      <div className="otp-email-display">
                        <span>OTP sent to: <strong>{email}</strong></span>
                        <Button
                          type="link"
                          size="small"
                          onClick={resetOtpFlow}
                          style={{ color: 'var(--auth-primary)', padding: 0 }}
                        >
                          Change
                        </Button>
                      </div>
                      <p className="otp-spam-hint">📧 Can't find the email? Check your spam folder</p>

                      <Input.OTP
                        length={6}
                        value={otp}
                        onChange={(value) => setOtp(value)}
                        size="large"
                        disabled={otpVerifying}
                      />
                      {errors.otp && <p className='auth-error'>{errors.otp}</p>}

                      <Button
                        type="primary"
                        className="auth-submit-btn"
                        size="large"
                        onClick={handleVerifyOtp}
                        loading={otpVerifying}
                      >
                        Verify & Login
                      </Button>

                      <div className="otp-resend">
                        {otpTimer > 0 ? (
                          <span className="otp-timer">Resend OTP in {otpTimer}s</span>
                        ) : (
                          <Button
                            type="link"
                            onClick={handleSendOtp}
                            loading={otpSending}
                            style={{ color: 'var(--auth-primary)', padding: 0 }}
                          >
                            Resend OTP
                          </Button>
                        )}
                      </div>
                    </>
                  )}
                </>
              )}
            </div>

            {/* Back to Instagram option */}
            <Button
              type="link"
              onClick={() => setShowEmailLogin(false)}
              style={{ marginTop: '12px', color: 'var(--auth-text-muted)' }}
            >
              ← Back to Instagram login
            </Button>
          </>
        )}
      </>
    );
  }

  // ========================================
  // SIGNUP COMPONENT
  // ========================================
  function SignupComp() {
    const [fullname, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [rpassword, setRPassword] = useState('');
    const [refCode, setRefCode] = useState('');
    const [errors, setErrors] = useState({});
    const [response, setResponse] = useState({});
    const [accountType, setAccountType] = useState(false);
    const [payload, setPayload] = useState({});
    const [submitting, setSubmitting] = useState(false);
    const [disablerefInput, setDisableRefInput] = useState(false);

    useEffect(() => {
      messageApi.destroy();
      if (response?.code === 200) {
        handleSuccess(payload);

        localStorage.setItem("token", response.data.token);
        sessionStorage.clear();
        localStorage.removeItem("refCode");
        localStorage.setItem("userData", JSON.stringify(response.data.data));

        navigate('/ig-connect?show_ig_connect=true');
      }
      if (response?.code && response.code !== 200) {
        messageApi.open({
          type: 'error',
          content: response.message,
        });
      }
    }, [response]);

    const handleSuccess = async (data) => {
      try {
        await sendWelcomeEmail(data);
      } catch (error) {
        console.error(error);
      }
    };

    const sendWelcomeEmail = async (data) => {
      await fetch(`https://send-welcome-email.sanjayhotaction.workers.dev/?email=${data?.email}&name=${data?.name}`);
    };

    useEffect(() => {
      if (payload?.email) {
        setSubmitting(true);
        messageApi.open({
          key: "signup loading",
          type: 'loading',
          content: 'Creating Account...',
        });

        const user_tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        callAPI({
          url: 'user-signup',
          method: "POST",
          body: { ...payload, user_tz },
          loadingState: setSubmitting,
          dataState: setResponse
        });

        // NocoDB tracking
        const now = new Date();
        const formattedDateTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

        if (ncid) {
          fetch("https://app.nocodb.com/api/v2/tables/mm4ydtsjnqh6gid/records", {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/json',
              "xc-token": "feFZVvr1uKXprz_xkJkmVqYwIp4UL_3fsm19yBkq"
            },
            body: JSON.stringify([{ Id: ncid, "email_id": payload?.email, "status": "signup", "signup-at": formattedDateTime }])
          }).catch(error => console.error('Error tracking signup:', error));
        }
      }
    }, [payload]);

    const handleSignup = () => {
      const validationErrors = {};

      if (!fullname) {
        validationErrors.fullname = 'Name is required';
      } else if (fullname.length < 3) {
        validationErrors.fullname = 'Name must be at least 3 characters long';
      }

      if (!email) {
        validationErrors.email = 'Email is required';
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
        validationErrors.email = 'Invalid email address';
      }

      if (!password) {
        validationErrors.password = 'Password is required';
      } else if (password.length < 8) {
        validationErrors.password = 'Password must be at least 8 characters long';
      }

      if (!rpassword) {
        validationErrors.rpassword = 'Repeat password is required';
      } else if (rpassword !== password) {
        validationErrors.rpassword = 'Passwords do not match';
      }

      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
      } else {
        setErrors({});

        const params = new URLSearchParams(window.location.search);
        const urlParams = {};
        for (const [key, value] of params.entries()) {
          urlParams[key] = value;
        }

        setPayload({
          fullname,
          email,
          password,
          refCode,
          agency: accountType,
          ...urlParams
        });
      }
    };

    useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const ref = params.get('ref');
      if (ref) {
        localStorage.setItem('refCode', ref);
        setDisableRefInput(true);
        setRefCode(ref);
      } else {
        const storedRef = localStorage.getItem('refCode');
        if (storedRef) setRefCode(storedRef);
      }
    }, []);

    return (
      <>
        {/* Instagram Signup - Primary Option */}
        <Button
          className="social-login-btn instagram"
          onClick={handleInstagramLogin}
          icon={<InstagramOutlined />}
          size='large'
        >
          Continue With Instagram
        </Button>
        <p className="secure-login-note">
          <LockOutlined /> Secured login using official Instagram API
        </p>

        <p className='auth-terms' style={{ marginTop: '24px' }}>
          By proceeding, you agree to <a href='https://instantdm.com/privacy' target='_blank' rel="noreferrer">our terms and conditions.</a>
        </p>
      </>
    );
  }

  // ========================================
  // MAIN RENDER
  // ========================================
  return (
    <div className="auth-page">
      {contextHolder}

      {/* Left Side - Branding Panel */}
      <div className="auth-branding">
        {/* Floating Keywords */}
        <div className="floating-keywords">
          <span className="floating-keyword" style={{ top: '12%', left: '8%', animationDelay: '0s' }}>Comment PP</span>
          <span className="floating-keyword" style={{ top: '25%', right: '10%', animationDelay: '0.5s' }}>Comment Link</span>
          <span className="floating-keyword" style={{ top: '45%', left: '5%', animationDelay: '1s' }}>Comment Price</span>
          <span className="floating-keyword" style={{ bottom: '35%', right: '8%', animationDelay: '1.5s' }}>Comment Address</span>
          <span className="floating-keyword" style={{ bottom: '20%', left: '12%', animationDelay: '2s' }}>Comment Location</span>
          <span className="floating-keyword" style={{ top: '15%', right: '25%', animationDelay: '2.5s' }}>Comment PDF</span>
          <span className="floating-keyword" style={{ bottom: '45%', left: '15%', animationDelay: '3s' }}>Comment Guide</span>
          <span className="floating-keyword" style={{ bottom: '12%', right: '20%', animationDelay: '3.5s' }}>Comment AI</span>
        </div>

        <div className="branding-content">
          <div className="partnership-logos">
            <img
              src="/logo192.png"
              alt="InstantDM Logo"
              className="branding-logo"
            />
            <span className="partnership-x">×</span>
            <img
              src="https://framerusercontent.com/images/wXj9XrHIPCGnc982zfYTj9zNBg.png?width=526&height=273"
              alt="Meta Business Partner"
              className="meta-business-partner-logo"
            />
          </div>
          <h1 className="branding-title">
            Automate Your Instagram & Facebook DMs
          </h1>
          <p className="branding-subtitle">
            Turn comments into conversations. Boost engagement and grow your business with powerful automation tools trusted by 30,000+ creators.
          </p>

          {/* Reviews Ticker */}
          <div className="ticker-section">
            <div className="ticker-container reviews-ticker">
              <div className="ticker-track">
                {/* Duplicate items for seamless loop */}
                {[...Array(2)].map((_, setIndex) => (
                  <div className="ticker-content" key={setIndex}>
                    {REVIEWS_DATA.map((review, index) => (
                      <div className="review-card" key={index}>
                        <div className="review-stars">
                          <StarFilled /><StarFilled /><StarFilled /><StarFilled /><StarFilled />
                        </div>
                        <p className="review-text">
                          "{review.text}{review.text ? ' ' : ''}<span className="highlight">{review.highlightText}</span> {review.fullText}"
                        </p>
                        <span className="review-author">— {review.author}</span>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Creators Ticker */}
          <div className="ticker-section creators-section">
            <div className="ticker-container creators-ticker">
              <div className="ticker-track ticker-reverse">
                {[...Array(2)].map((_, setIndex) => (
                  <div className="ticker-content" key={setIndex}>
                    {CREATORS_DATA.map((creator, index) => (
                      <div className="creator-card" key={index}>
                        <div className="creator-image">
                          <img src={creator.image} alt={creator.name} />
                        </div>
                        <div className="creator-info">
                          <span className="creator-name">{creator.name}</span>
                          <div className="creator-niches">
                            {creator.niches.map((niche, nIndex) => (
                              <span className="niche-tag" key={nIndex}>{niche}</span>
                            ))}
                          </div>
                          <span className="creator-followers">{creator.followers} followers</span>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Right Side - Auth Form Panel */}
      <div className="auth-form-panel">
        <div className="auth-card">
          {/* Partnership logos - shown on mobile only */}
          <div className="partnership-logos mobile-only">
            <img
              src="/logo192.png"
              alt="InstantDM Logo"
              className="branding-logo"
            />
            <span className="partnership-x">×</span>
            <img
              src="https://framerusercontent.com/images/wXj9XrHIPCGnc982zfYTj9zNBg.png?width=526&height=273"
              alt="Meta Business Partner"
              className="meta-business-partner-logo"
            />
          </div>

          {/* Header */}
          <div className="auth-header">
            <h2>{isSignup ? 'Create your account' : 'Welcome back 👋'}</h2>
            <p>{isSignup ? 'Start your free 7-day trial' : 'Login to your InstantDM account'}</p>
          </div>

          {/* Auth Form Content */}
          {isSignup ? <SignupComp /> : <LoginComp />}

          {/* Footer */}
          <div className="auth-footer">
            <Button
              className="auth-switch-btn"
              href={isSignup ? '/login' : '/signup'}
            >
              {isSignup ? 'Already have an account? Login' : 'Create new account'}
            </Button>
            <Button
              className="auth-help-btn"
              target="_blank"
              href='https://instagram.com/instant.dm'
            >
              Need Help? Contact us - Quick Support
            </Button>
          </div>

          {/* Trust Badges */}
          <div className="trust-badges auth-trust-badges">
            <img
              src="https://framerusercontent.com/images/c0o1mNbHLKhdEqHalSsh1qOJ8.webp?width=50&height=50"
              alt="Meta Partner"
              className="trust-badge"
            />
            <img
              src="https://framerusercontent.com/images/MabHaaNcQ4teDx1Kd9uNrQUL1c.png?scale-down-to=512&width=558&height=125"
              alt="Instagram Partner"
              className="trust-badge"
            />
            <img
              src="https://framerusercontent.com/images/OsRHaZK5SG3gj7UNjoPBIQQCw.svg?width=133&height=45"
              alt="App Store Partner"
              className="trust-badge"
            />
            <img
              src="https://framerusercontent.com/images/BserlDMbsbbZLyzPNawjFV9MtY.svg?width=150&height=45"
              alt="Play Store Partner"
              className="trust-badge"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthPage;